import Settings from "./Settings"
import { useState } from "react"
import SettingsTabs from "../SettingsTabs"
import EmailTemplateTypeList from "../../EmailTemplates/EmailTemplateTypeList"
import { EmailTemplateTypes } from "../../../common/constants"

const tabs = [
  { key: 'settings', label: 'Settings' },
  { key: 'email-templates', label: 'Email Templates' }
]

const ProposalSettings = () => {
  const [selectedTab, setSelectedTab] = useState('settings')

  return <SettingsTabs selectedTab={selectedTab} onTabChange={setSelectedTab} tabs={tabs}>
    {selectedTab === 'settings' && <Settings onEditEmailTemplates={() => setSelectedTab('email-templates')} />}
    {selectedTab === 'email-templates' && <EmailTemplateTypeList emailTemplateType={EmailTemplateTypes.Proposal} />}
  </SettingsTabs>
}

export default ProposalSettings
